<ng-container *ngIf="!prefixed">
  <mat-form-field floatPlaceholder="never" [ngClass]="noPrefixedNgClassObject">
    <label for="{{controlName}}" [ngClass]="{ 'disableLabel': disabled }">
      {{label}}
      <span *ngIf="optLabel" class="optional-label">{{optLabel}}</span>
      <span *ngIf="required" class="required">*</span>
      <span
        *ngIf="isToolTipRequired" matTooltip="{{tooltipText}}"
        matTooltipPosition="{{tooltipConfig?.position}}">
        <mat-icon color="primary">info</mat-icon>
      </span>
    </label>
    <input
      id="{{controlName}}"
      matInput
      type="text"
      [ivNumericDirective]="currencyOptions"
      [maskito]="maskitoCurrencyOptions"
      [(ngModel)]="fieldValue"
      (input)="writeValue($event.target.value)"
      [disabled]="disabled"
      [ngStyle]="customStyles"
      (blur)="propagateTouched();onBlur($event.target.value);"
    />
    <span class="currency-label-mat-suffix" matSuffix>{{currency}}</span>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="prefixed">
  <mat-form-field floatPlaceholder="never" [ngClass]="prefixedNgClassObject">
    <label *ngIf="label" [ngClass]="{ 'disableLabel': disabled }" for="{{controlName}}">
      {{label}}
      <span *ngIf="optLabel" class="optional-label">{{optLabel}}</span>
      <span *ngIf="required" class="required">*</span>
      <span
        *ngIf="isToolTipRequired" matTooltip="{{tooltipText}}"
        matTooltipPosition="{{tooltipConfig?.position}}">
        <mat-icon color="primary">info</mat-icon>
      </span>
    </label>
    <span class="currency-label-mat-prefix" matPrefix>{{ currency }}</span>
    <input
      id="{{controlName}}"
      matInput
      type="text"
      [ivNumericDirective]="currencyOptions"
      [maskito]="maskitoCurrencyOptions"
      [(ngModel)]="fieldValue"
      (input)="writeValue($event.target.value)"
      [disabled]="disabled"
      [ngStyle]="customStyles"
      (blur)="propagateTouched();onBlur($event.target.value);"
    />
  </mat-form-field>
</ng-container>